module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAo0lEQVR4AWOgD2ggFiE0hC9guH2JYcU+IIM4DadOM2j0M3A1M2w4iEXdjJ0MPC2oGl5dZzh7hqGpleHmRQbdiQxXzjMs3MPgNguqga8VRHI2ozrp1l6Grc0gxsVzDA0boEojFjIwNYIYbE0Mi/fi8PT/+ww206Ds0AUM7M0ghv4kIIldA9wGFCTagVMDph8glqBoIIAW7GHgRg0lYhBZGgYnAABowGfUx8+h8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CC.png
// module id = 1104
// module chunks = 0